export enum CommunityMemberStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  INVITED = 'INVITED',
}
